import { z } from 'zod';
import { mongoObjectIdString, optionalMongoObjectId, requiredMongoObjectId } from '../object-id-helpers.js';

const TemplateFieldSchema = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    label: z.string().optional(),
    type: z.string().optional(),
}).passthrough();

const TemplateSectionSchema = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
}).passthrough();

export const CreateTicketTemplateSchema = z.object({
    name: z.string().min(1),
    code: z.string().optional(),
    description: z.string().optional(),
    category: optionalMongoObjectId,
    fields: z.array(TemplateFieldSchema).optional(),
    sections: z.array(TemplateSectionSchema).optional(),
    defaultSla: optionalMongoObjectId,
    defaultServiceCatalogItem: requiredMongoObjectId,
    itsmClass: z.enum(['service_request', 'incident']),
    problemDetectionEnabled: z.boolean().optional().nullable(),
    defaultWorkflowTemplate: optionalMongoObjectId,
    defaultAssignmentTemplate: optionalMongoObjectId,
    defaultPriority: z.enum(['critical', 'high', 'medium', 'low']).optional(),
    status: z.enum(['draft', 'published', 'archived']).optional(),
}).passthrough();

export const UpdateTicketTemplateSchema = CreateTicketTemplateSchema.partial();
export { mongoObjectIdString };
